import React from "react";
import ReactGA from "react-ga";

if (process.env.REACT_APP_NODE_ENV === "production") {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
} else {
  ReactGA.initialize("UA-000000-01");
}

const WithAnalytics = WrappedComponent => {
  const trackPage = page => {
    ReactGA.set({ page });
    ReactGA.pageview(page);
  };

  const HOC = props => {
    const page = props.location.pathname;
    switch (page.split('/')[1]) {
      case "news":
        document.title = 'C More Sisäpiiri - Uutiset';
        break;
      case "product-categories":
        document.title = 'C More Sisäpiiri - Tuotteet';
        break;
      case "prizes":
        document.title = 'C More Sisäpiiri - Palkinto-ohjelma';
        break;
      case "admin":
        document.title = 'C More Sisäpiiri - Admin';
        break;
      default:
          document.title = 'C More Sisäpiiri';
        break;
    }
    trackPage(page);
    return <WrappedComponent {...props} />;
  };

  return HOC;
};

export default WithAnalytics;



// WEBPACK FOOTER //
// ./src/modules/core/Analytics.js